<template>
  <vue-aos animation-class="slide-in animated" :threshold="0">
    <section class="team section-margin section-padding">
      <div class="text-center">
        <h1 class="underline text-white letter-spacing-md">Team Leads</h1>
      </div>
      <div class="container mb-4 mt-5">
        <div class="row justify-content-center">
          <div
            class="col-lg-4 col-sm-6 col-12"
            :class="{ 'mb-3 mb-md-0': index < team.length - 1 }"
            v-for="(member, index) in team"
            :key="member.name"
          >
            <div class="card p-3 box-shadow border-0 text-center h-100">
              <div class="team__member__content">
                <div class="mb-3">
                  <img width="125" height="125" v-lazy="member.img" />
                </div>
                <h3 class="letter-spacing-md">{{ member.name }}</h3>
                <h5 class="text-portfolio3 letter-spacing-sm">
                  {{ member.role }}
                </h5>
                <p class="m-0 letter-spacing-sm">{{ member.about }}</p>

                <!-- <div class="d-flex justify-content-center mt-3 mt-md-0">
                  <button
                    class="btn btn-outline-portfolio3 team__contact d-block w-75  mx-auto"
                    v-scroll-to="{
                      el: '.contact__form',
                      container: 'body',
                      duration: 1000,
                      easing: 'linear',
                      offset: 0,
                      force: true,
                      cancelable: true,

                      x: false,
                      y: true,
                    }"
                  >
                    Contact
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </vue-aos>
</template>

<script>
export default {
  data() {
    return {
      team: [
        {
          name: "Muhammad Musab",
          role: "App Developer",
          about:
            "He is Full Stack Web & App developer specialized in React-Native , Vue and Nodejs. He has worked on several Front-End & Back-End projects.",
          img: require("../../assets/images/home/team/member4.png"),
        },
        {
          name: "Muhammad Ziauddin",
          role: "Back End Developer",
          about:
            "Zia is a Back-End developer specialized Laravel Framework. He has worked on larger projects like patient management system.",
          img: require("../../assets/images/home/team/member2.png"),
        },
        // {
        //   name: "Abdul Wahid",
        //   role: "Founder / CEO",
        //   about:
        //     "Mr Abdul Wahid is CEO and Founder of Robust Office. He has 15 years of experience in an I.T field , he is entrepreneur and has good marketing experience.",
        //   img: require("../../assets/images/home/team/member3.png"),
        // },
        {
          name: "Muhammad Shumas",
          role: "Front End Developer",
          about:
            "He is Full Stack Front-End developer specialized in Html , CSS ,Javascript & Vue js. Mr Shumas has very good  front-end skills.",
          img: require("../../assets/images/home/team/member1.png"),
        },
      ],
    };
  },
};
</script>

<style></style>
